export default __webpack_public_path__ + "static/media/progress.adc19713.png";